/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState } from 'react';
import { object, func } from 'prop-types';
import MobileRecipientCard from './RecepientCard';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
const useStyles = makeStyles(() => ({
    card: {
        '& .mbp-account-MuiPaper-root': {
            marginBottom: '16px',
            borderRadius: '8px',
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
            fontFamily: 'Lato',
        },
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '16px',
    },
    paginationItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px 12px !important',
        margin: '0 4px !important',
        background: 'transparent !important',
        color: 'black !important',
        border: 'none !important',
        boxShadow: 'none !important',
        cursor: 'pointer !important',
        minWidth: '10px !important',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08) !important',
        },
        '&.Mui-selected':{
            backgroundColor: 'rgba(0, 0, 0, 0.08) !important',
        }
    },
}));

const RecipientList = ({ recipients, setIsRecipientListVisible, setOtherOption, handleOptionChange }) => {
    const classes = useStyles();
    const [page, setPage] = useState(1);
    const itemsPerPage = 5;
    const totalPages = Math.ceil((recipients?.addressBookResponse?.addressList?.length || 0) / itemsPerPage);
    const currentItems = recipients?.addressBookResponse?.addressList?.slice((page - 1) * itemsPerPage, page * itemsPerPage);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    return (
        <div className={classes.card}>
            {currentItems?.length > 0 ? (
                currentItems.map((recipient) => (
                    <MobileRecipientCard
                        key={recipient?.rcpId}
                        recipient={recipient}
                        setIsRecipientListVisible={setIsRecipientListVisible}
                        setOtherOption={setOtherOption}
                        handleOptionChange={handleOptionChange}
                    />
                ))
            ) : (
                <p style={{ textAlign: 'center' }}>No Contacts Found</p>
            )}
            {totalPages > 1 && (
                <div className={classes.pagination}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        renderItem={(item) => (
                            <PaginationItem
                                {...item}
                                classes={{ root: classes.paginationItem}}
                                disableRipple
                            />
                        )}
                    />
                </div>
            )}
        </div>
    );
};

RecipientList.propTypes = {
    recipients: object.isRequired,
    setIsRecipientListVisible: func,
    setOtherOption: func,
    handleOptionChange: func.isRequired,
};

export default RecipientList;
